import { render, staticRenderFns } from "./order-create-client.vue?vue&type=template&id=688d62ff&"
import script from "./order-create-client.ts?vue&type=script&lang=ts&"
export * from "./order-create-client.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports